import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { BaseAuthService } from '@libs/core/auth';

@NgModule({
  imports: [CommonModule],
})
export class AuthFmaModule {
  constructor() {
    const module = inject(AuthFmaModule, { optional: true, skipSelf: true });

    if (module) {
      throw new Error(`${AuthFmaModule.name} should be imported only once!`);
    }
  }

  static forRoot(): ModuleWithProviders<AuthFmaModule> {
    return {
      ngModule: AuthFmaModule,
      providers: [
        AuthService,
        {
          provide: BaseAuthService,
          useExisting: AuthService,
        },
      ],
    };
  }
}
